import { Record } from "immutable";

const InitialState = new Record({
  activeTheme: "default",
  stateRestored: false,
  permissionsClarified: false,
  cacheRestored: false,
});

export default InitialState;



// WEBPACK FOOTER //
// ./src/model/subsystems/app/reducer/InitialState.js